import React, { Component } from "react";
import Select from "react-select";
import { DateInput, TimePicker } from "@blueprintjs/datetime";
import CreatableSelect from "react-select/creatable";
import { withFirebase } from "../Firebase";
import Spinner from "react-md-spinner";
import {
  Label,
  NumericInput,
  Position,
  Switch,
  InputGroup,
  Checkbox,
  Button,
  RadioGroup,
  Radio,
  Dialog,
} from "@blueprintjs/core";
import { Grid, Row, Col } from "react-flexbox-grid";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import Repeat from "react-repeat-component";
import "./index.css";
import RichTextEditor from "../RichTextEditor";
import ImageUpload from "../ImageUpload";
import FormCreation from "../FormCreation";

const jsDateFormatter = {
  // note that the native implementation of Date functions differs between browsers
  formatDate: (date) => date.toLocaleDateString(),
  parseDate: (str) => new Date(str),
  placeholder: "M/D/YYYY",
};

class AddEventsBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      onCreate: false,
      event_type: "",
      instructors: [],
      isGuest: false,
      category: "",
      event_name_ar: "",
      confirmation_type: "",
      event_name: "",
      difficulty: "",
      max_attendees: 0,
      live_stream_state: false,
      waitlist: false,
      numdays: 0,
      event_date: [],
      contributors: [],
      expected_attendees: 0,
      venue: "",
      city: "",
      event_type: "",
      venues: [],
      dropdownFlag: false,
      googleMaps: "",
      programs: [],
      program: "",
      center: "",
      programIsNew: false,
      venueIsNew: false,
      notes: "",
      for_whom: "",
      desc_rte: "",
      short_desc: "",
      see_more: "",
      imageProps: "",
      event_number: 0,
      questions: [],
      form: {},
      target_audience: "",
      survey: [],
      typeFormSurvey: "",
      follow_up_date: new Date(),
    };
  }

  setImageProps = (url, name, size, type) => {
    this.setState({
      imageProps: {
        imageUrl: url,
        imageName: name,
        imageSize: size,
        imageType: type,
      },
    });
  };

  setCategory = (program) => {
    this.props.firebase.programs().onSnapshot((snapshot) => {
      snapshot.forEach((doc) => {
        if (doc.data().name === program) {
          console.log(doc.data().category);
          this.setState({ category: doc.data().category });
        }
      });
    });
  };

  getGoogleMapsLink(venue) {
    console.log("getGoogleMapsLink");
    this.props.firebase.venues().onSnapshot((snapshot) => {
      snapshot.forEach((doc) => {
        if (doc.data().name === venue) {
          this.setState({ googleMaps: doc.data().google_maps });
        }
      });
    });
  }

  async componentDidMount() {
    this.setState({ loading: true });
    var contributors = this.state.contributors;
   await  this.props.firebase.teamMembers().onSnapshot((snapshot) => {
      snapshot.forEach((doc) => {
        var user_ref = doc.data().user;
        if (user_ref != undefined) {
          user_ref.get().then((doc) => {
            contributors.push({
              label: doc.data().firstname + " " + doc.data().familyname,
              value: doc.id,
              collection: "users",
            });
          });
        }
      });
    });
 
    var venues = this.state.venues;
    await this.props.firebase.venues().onSnapshot((snapshot) => {
      snapshot.forEach((doc) => {
        venues.push({
          label: doc.data().name,
          value: doc.id,
        });
      });
    });
    this.setState({ venues: venues });
    var programs = this.state.programs;
  await  this.props.firebase.programs().onSnapshot((snapshot) => {
      snapshot.forEach((doc) => {
        programs.push({
          label: doc.data().name,
          value: doc.id,
        });
      });
    });
    this.setState({ programs: programs });
   await this.props.firebase.events().onSnapshot((snapshot) => {
      var length = snapshot.size + 1;
      this.setState({ event_number: length });
    });

   this.setState({loading: false});
  }

  handleClose = (event) => {
    this.setState({ isOpen: false });
    window.location = "/home";
  };

  onChangeText = (event) => {
    this.setState({ event_name: event.target.value });
    var id =
      event.target.value.replace(/ /g, "_") + "_" + this.state.event_number;
    this.setState({ id: id });
  };

  onCreateEvent = (event) => {
    console.log("4");
    console.log(JSON.stringify(this.state.questions));
    event.preventDefault();
    console.log("Pressed submit");
    this.setState({onCreate: true}); 
    if (this.state.event_name !== "") {
      console.log(this.state);
      let event_data = {
        event_name: this.state.event_name,
        event_name_ar: this.state.event_name_ar,
        desc: this.state.desc_rte.toString("markdown"),
        created_date: new Date(),
        event_type: this.state.event_type,
        confirmation_type: this.state.confirmation_type,
        difficulty: this.state.difficulty,
        max_attendees: this.state.max_attendees,
        livestream: this.state.live_stream_state,
        waitlist: this.state.waitlist,
        event_date: this.state.event_date,
        center_type: this.state.center,
        isGuest: this.state.isGuest,
        isCanceled: false,
        expected_attendees: this.state.expected_attendees,
        venue: this.state.venue,
        city: this.state.city,
        event_confirmation_status: false,
        google_maps: this.state.googleMaps,
        program: this.state.program,
        category: this.state.category,
        notes: this.state.notes,
        for_whom: this.state.for_whom,
        desc_webflow: this.state.desc_rte,
        short_desc: this.state.short_desc,
        see_more: this.state.see_more,
        imageProps: this.state.imageProps,
        registrations: [],
        registrationids: [],
        instructors: this.state.instructors.length === 0 ? []
            : this.state.instructors.map((instructor) =>
                this.props.firebase.ref(instructor.value, instructor.collection)
              ),
        form: {
          questions: this.state.questions,
          event_id: this.state.id.toString(),
        },
        target_audience: this.state.target_audience,
        follow_up_date: this.state.follow_up_date,
        done: null,
      };
      
    
      console.log("data", event_data);

      this.props.firebase
        .events()
        .doc(this.state.id.toString())
        .set(event_data).then(() => {
                  console.log("event created successfully....");
                  this.setState({
                    onCreate: false,
                    isOpen: true,
                  });
        });

      
    }
  };

  handleNumberOfQuestionsChange = (num) => {
    var form = this.state.form;
    while (num > form.questions.length) {
      form.questions.push("");
    }
    while (num < form.questions.length) {
      form.questions.pop();
    }
    this.setState({ form: form });
  };
  handleTypeRadioChange = (event) =>
    this.setState({
      eventType: event.currentTarget.value,
    });

  handleDifficultyRadioChange = (event) =>
    this.setState({
      difficulty: event.currentTarget.value,
    });

  onValueChange = (num, string) => {
    if (num !== 0) {
      num = parseInt(num);
      this.setState({
        numdays: num,
      });
      var preFunctionArray = this.state.event_date;
      while (preFunctionArray.length > num) {
        preFunctionArray.pop();
      }
      //in the case of no excess being removed, these two arrays are the same
      var removedExcessArray = preFunctionArray;
      this.setState({
        eventDate: removedExcessArray,
      });
      var local_event_date = this.state.event_date;
      //this part of the function adds values to the eventDate if required.
      //will not run if theres no need to add anymore values
      if (removedExcessArray.length < num) {
        for (var i = removedExcessArray.length; i < num; i++) {
          var local_date_object = {
            date: new Date(),
            start_time: new Date(),
            end_time: new Date(),
          };
          local_event_date.push(local_date_object);
        }
        this.setState({ event_date: local_event_date });
      }
    }
  };

  setDay = (newDay, i) => {
    var event_date = this.state.event_date;
    event_date[i].date = newDay;
    this.setState({ event_date: event_date });
  };

  setFollowUpDay = (newDay) => {
    this.setState({ follow_up_date: newDay });
  };

  setStartTime = (newTime, i) => {
    var event_date = this.state.event_date;
    event_date[i].start_time = newTime;
    event_date[i].date.setHours(newTime.getHours());
    event_date[i].date.setMinutes(newTime.getMinutes());
    event_date[i].date.setSeconds(0);
    event_date[i].date.setMilliseconds(0); 
    this.setState({ event_date: event_date });
  };

  setEndTime = (newTime, i) => {
    var event_date = this.state.event_date;
    event_date[i].end_time = newTime;
    this.setState({ event_date: event_date });
  };

  setQuestions = (questions) => {
    this.setState({ form: questions });
  };

  setSurveyQuestions = (questions) => {
    this.setState({ survey: questions });
  };

  getSurvey = (program) => {
    this.props.firebase
      .programs()
      .doc(program)
      .get()
      .then((doc) => {
        let survey = doc.data().survey;
        console.log(survey);
        if (survey !== undefined) {
          this.setState({ survey: survey });
        }
      });
  };

  getForm = (program) => {
    this.props.firebase
      .programs()
      .doc(program)
      .get()
      .then((doc) => {
        let form = doc.data().form;
        console.log(form);
        if (form !== undefined) {
          this.setState({ questions: form });
        }
      });
  };

  handleQuestionTextChange = (event, i) => {
    var form = this.state.form;
    form.questions[i] = event.target.value;
    this.setState({ form: form });
  };

  render() {
    const { event,onCreate, loading, value, eventType, difficulty } = this.state;
 

    if(loading || onCreate) return (
                  <Spinner
                    size={100}
                    style={{ marginTop: "20%", marginLeft: "50%" }}
                    singleColor="#1673b5"
                  />
                );
    else return (<div>
      
        <Grid className="margin-top">
          <Row>
            <form>
              <Label>
                Event Name
                <InputGroup
                  placeholder="Event Name"
                  onChange={this.onChangeText}
                />
              </Label>
              <Label>
                Event name(Arabic):
                <InputGroup
                  placeholder="Event Name (Arabic)"
                  onChange={(input) =>
                    this.setState({ event_name_ar: input.target.value })
                  }
                />
              </Label>
              <Label>
                <RadioGroup
                  inline
                  label="Center Type"
                  selectedValue={this.state.center}
                  onChange={(event) => {
                    this.setState({
                      center: event.target.value,
                    });
                  }}
                >
                  <Radio label="IoT / CyS" value="iot-cys" />
                  <Radio label="AI/DS" value="ai-ds" />
                </RadioGroup>
              </Label>
              <Label>
                Program
                <CreatableSelect
                  value={
                    this.state.program === ""
                      ? null
                      : { label: this.state.program, value: "program" }
                  }
                  placeholder="Select an existing program or start typing to create a new one..."
                  onInputChange={(event, action) => {}}
                  onChange={(event, action) => {
                    this.setState({
                      program: event.label,
                    });
                    this.setCategory(event.label);
                    this.setState({ programIsNew: false });
                    this.getSurvey(event.value);
                    this.getForm(event.value);
                  }}
                  onCreateOption={(string) => {
                    this.setState({ program: string });
                    this.setState({ programIsNew: true });
                  }}
                  options={this.state.programs}
                />
              </Label>
              <Label>
                Event Type
                <Select
                  options={[
                    { label: "Webinar", value: "Webinar" },
                    { label: "Lecture", value: "Lecture" },
                    { label: "Bootcamp", value: "Bootcamp" },
                    { label: "Other", value: "Other" },
                    { label: "Meet-Up", value: "Meet-Up" },
                    { label: "Consultations", value: "Consultations" },
                    { label: "Internal", value: "Internal" },
                    { label: "Challenges", value: "Challenges" },
                    { label: "External", value: "External" },
                    { label: "Conference ", value: "Conference " },
                  ]}
                  onChange={(value) => {
                    this.setState({ event_type: value.value });
                    if (value.value == "Webinar") {
                      this.setState({
                        googleMaps: "",
                        venue: "عبر الإنترنت",
                      });
                    }
                  }}
                />
              </Label>
              <Label>
                <Checkbox
                  label="instructor is guest"
                  onChange={() =>
                    this.setState({ isGuest: !this.state.isGuest })
                  }
                />
              </Label>
              <Label>
                Add multi instructors
                <Select
                  value={this.state.instructors}
                  options={this.state.contributors}
                  isMulti
                  onChange={(value) => {
                    if (value !== null) {
                      let filterlist = [];
                      for (let i = 0; i < value.length; i++) {
                        filterlist.push(value[i]);
                      }

                      this.setState({ instructors: filterlist });
                    } else {
                      this.setState({ instructors: [] });
                    }
                  }}
                ></Select>
              </Label>
              <Label>
                Venue(Please enter an arabic value)
                <CreatableSelect
                  placeholder={
                    "Select an existing venue or create a new one..."
                  }
                  value={
                    this.state.venue === ""
                      ? null
                      : { label: this.state.venue, value: "venue" }
                  }
                  onChange={(event, action) => {
                    this.setState({ venue: event.label });
                    this.getGoogleMapsLink(event.label);
                    this.setState({ venueIsNew: false });
                  }}
                  onCreateOption={(string) => {
                    this.setState({ venue: string });
                    this.setState({ venueIsNew: true });
                  }}
                  options={this.state.venues}
                />
                <InputGroup
                  disabled={
                    !(this.state.venueIsNew || this.state.venue === "Webinar")
                  }
                  value={this.state.googleMaps}
                  placeholder={
                    this.state.venue === "Webinar"
                      ? "Insert Webinar Link"
                      : "Insert Google Maps Link"
                  }
                  onChange={(event) => {
                    this.setState({ googleMaps: event.target.value });
                  }}
                />
              </Label>
              <Label>
                City
                <Select
                  options={[
                    {
                      label: "عبر الإنترنت ( Webinar )",
                      value: "عبر الإنترنت ( Webinar )",
                    },
                    { label: "", value: "" },
                    { label: "الخبر", value: "الخبر" },
                    { label: "الرياض", value: "الرياض" },
                    { label: "الجبيل", value: "الجبيل" },
                    { label: "جدة", value: "جدة" },
                    { label: "Riyadh", value: "Riyadh" },
                    { label: "المدينة المنورة", value: "المدينة المنورة" },
                    { label: "المدينة", value: "المدينة" },
                    { label: "الاحساء", value: "الاحساء" },
                    { label: "Dubai", value: "Dubai" },
                  ]}
                  onChange={(value) => {
                    this.setState({ city: value.value });
                  }}
                />
              </Label>
              <Label>
                Number of days
                <NumericInput
                  buttonPosition="right"
                  value={this.state.numdays}
                  onValueChange={this.onValueChange}
                  allowNumericCharactersOnly={true}
                  large={false}
                  min={0}
                />
              </Label>
              <Row>
                <Repeat times={this.state.numdays}>
                  {(i) => (
                    <div className="margin-below" key={i}>
                      <Row>
                        <div style={{ float: "left" }}>
                          <Label>
                            <strong> Day {i + 1} </strong> -
                          </Label>
                          <DateInput
                            {...jsDateFormatter}
                            className="display-block"
                            popoverProps={{ position: Position.BOTTOM }}
                            onChange={(newDay) => {
                              if (newDay !== null) this.setDay(newDay, i);
                            }}
                            maxDate={new Date(2040, 11, 11)}
                            value={this.state.event_date[i].date}
                          />
                        </div>
                      </Row>
                      <Col>
                        <Label> Start Time </Label>
                        <Col>
                          <TimePicker
                            onChange={(newTime) => {
                              this.setStartTime(newTime, i);
                            }}
                            value={this.state.event_date[i].start_time}
                          />
                        </Col>
                        <Label> End Time </Label>
                        <Col>
                          <TimePicker
                            onChange={(newTime) => {
                              this.setEndTime(newTime, i);
                            }}
                            value={this.state.event_date[i].end_time}
                          />
                        </Col>
                      </Col>
                    </div>
                  )}
                </Repeat>
              </Row>
              <RadioGroup
                inline
                label="Confirmation Type"
                name="group"
                selectedValue={this.state.confirmation_type}
                onChange={(event) => {
                  this.setState({
                    confirmation_type: event.target.value,
                  });
                }}
              >
                <Radio label="Auto Confirm" value="auto_confirm" />
                <Radio label="Filter Applicants" value="filter" />
              </RadioGroup>
              <RadioGroup
                label="Difficulty"
                inline
                selectedValue={this.state.difficulty}
                onChange={this.handleDifficultyRadioChange}
              >
                <Radio label="Easy" value="Easy" />
                <Radio label="Medium" value="Medium" />
                <Radio label="Hard" value="Hard" />
              </RadioGroup>
              <Label> Follow up date </Label>
              <DateInput
                {...jsDateFormatter}
                className="display-block"
                popoverProps={{ position: Position.BOTTOM }}
                onChange={(newDay) => {
                  if (newDay !== null) this.setFollowUpDay(newDay);
                }}
                maxDate={new Date(2040, 11, 11)}
                value={this.state.follow_up_date}
              />
              <Row middle="xs">
                <Col xs={3}>
                  <strong> Target Audiance: </strong>
                </Col>
                <Col xs={4}>
                  <Select
                    options={[
                      {
                        label: "General Events (فعاليات عامة)",
                        value: "General Events",
                      },
                      {
                        label: "Entrepreneurs (رواد أعمال)",
                        value: "Entrepreneurs",
                      },
                      {
                        label: "SMEs (أصحاب منشآت صغيرة ومتوسطة)",
                        value: "SMEs",
                      },
                    ]}
                    onChange={(value) => {
                      this.setState({ target_audience: value.value });
                    }}
                    defaultValue={{ value: true, label: "" }}
                  />
                </Col>
              </Row>

              <Label> Max Attendees </Label>
              <NumericInput
                buttonPosition="none"
                allowNumericCharactersOnly={true}
                large={false}
                min={0}
                onValueChange={(value) => {
                  this.setState({ max_attendees: value });
                }}
                value={this.state.max_attendees}
              />
              <Label> Expected Attendees </Label>
              <NumericInput
                buttonPosition="none"
                allowNumericCharactersOnly={true}
                large={false}
                min={0}
                onValueChange={(value) => {
                  this.setState({ expected_attendees: value });
                }}
                value={this.state.expected_attendees}
              />
              <Switch
                checked={this.state.live_stream_state}
                label="Live Stream"
                onChange={(event) => {
                  this.setState({
                    live_stream_state: event.target.checked,
                  });
                }}
              />
              <Switch
                checked={this.state.waitlist}
                label="Waitlist"
                onChange={(event) => {
                  this.setState({
                    waitlist: event.target.checked,
                  });
                }}
              />
              <Label>
                Short Description
                <InputGroup
                  onChange={(event) =>
                    this.setState({ short_desc: event.target.value })
                  }
                ></InputGroup>
              </Label>
              <Label>
                For whom
                <InputGroup
                  onChange={(event) =>
                    this.setState({ for_whom: event.target.value })
                  }
                ></InputGroup>
              </Label>
              <Label>
                Description
                <RichTextEditor
                  parentCallback={(data) => {
                    this.setState({ desc_rte: data });
                  }}
                />
              </Label>
              <Label>
                See More
                <RichTextEditor
                  parentCallback={(data) => {
                    this.setState({ see_more: data });
                  }}
                />
              </Label>
              <Label>
                Notes
                <RichTextEditor
                  parentCallback={(data) => {
                    this.setState({ notes: data });
                  }}
                />
              </Label>
              <ImageUpload
                id={this.state.id}
                allowMultiple={false}
                url={"events/" + this.state.id + "/assets/"}
                setImageProps={this.setImageProps}
                imageProps={this.state.imageProps}
              />
            </form>
          </Row>
          <Label> Filtration form </Label>
          <Button
            onClick={() => {
              this.setState({
                questions: [
                  {
                    isRequired: true,
                    options: [
                      "أواجه تحديات في هذا المجال و أرغب في إيجاد حل لها من خلال هذه الورشة",
                      "أرغب في إيجاد فرص جديدة  لتحسين العمل في منشأتي",
                      "أرغب في بدئ مشروع جديد قريبًا",
                      "أرغب في إيجاد وظيفة في هذا المجال",
                      "ليس لدي هدف محدد ولكني أرغب في التعرف على هذا الموضوع بشكل أكبر",
                    ],
                    text:
                      "مالذي دفعك للتسجيل في هذه الورشة؟ (اختر جميع ما ينطبق)",
                    type: "cbq",
                  },
                  {
                    type: "long_text",
                    options: [""],
                    isRequired: false,
                    text:
                      "مالذي دفعك للتسجيل في هذه الورشة؟ وماهي توقعاتك لمحتوى/ مخرجات الورشة؟",
                  },
                  {
                    type: "cbq",
                    options: [
                      "مواقع التواصل الاجتماعي الخاصة بالمركز",
                      "الموقع الرسمي للمركز",
                      "النشرة الإخبارية",
                      "إعلانات",
                      "أصدقاء",
                      "الإعلان عن ورش ذكاء عن طريق جهة أخرى (خاصة أو حكومية)",
                    ],
                    isRequired: true,
                    text: "كيف سمعت عن هذه الورشة؟ (اختر جميع ما ينطبق)",
                  },
                ],
              });
            }}
          >
            Set default filtration questions
          </Button>
          <Row>
            <Label>
              Number of questions
              <FormCreation
                getQuestions={(questions) => {
                  this.setQuestions(questions);
                }}
                questions={this.state.questions}
              />
            </Label>
          </Row>
        
          <Button
            className="margin-top"
            type="submit"
            icon="add"
            onClick={this.onCreateEvent}
          >
            Submit
          </Button>
          <Dialog
            isOpen={this.state.isOpen}
            canOutsideClickClose={true}
            onClose={this.handleClose}
          >
            <p> Successfully Created Event </p>
          </Dialog>
        </Grid>
      </div>
    );
  }
}

const AddEvents = withFirebase(AddEventsBase);

export default AddEvents;
